type ModalCallbacks = {
  onPrimary?: () => void
  onSecondary?: () => void
}

let _callbacks: ModalCallbacks = {}
let _generation = 0
let _consumed = false

export const setModalCallbacks = (cbs: ModalCallbacks): number => {
  _generation++
  _callbacks = cbs
  _consumed = false
  return _generation
}

export const consumeModalCallbacks = (generation: number): ModalCallbacks | null => {
  if (generation !== _generation || _consumed) return null
  _consumed = true
  const cbs = _callbacks
  _callbacks = {}
  return cbs
}
